import { InjectionToken } from "@angular/core";

export const SYSTEM_TRANSLATION_SCOPE = "system";
export interface TranslationEndpoints {
    getSystemTranslations: string;
}
export const TRANSLATION_ENDPOINTS = new InjectionToken<TranslationEndpoints>("Translation endpoints");
